import { DocumentMapping } from "@/configuration/document-mappings/types";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { getClassificationDisplay } from "@/src/lib/utils/classification";
import { Classification } from "@/src/models/constants/classifications";
import { V2WorkflowType } from "@/src/models/constants/workflow-types";

export const ADSS_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.REFERRAL]: {
    group: ConfigSubdomain.ADSS,
    classification: Classification.REFERRAL,
    displayName: getClassificationDisplay(Classification.REFERRAL, true),
    assignedTo: null,
    folder: null,
    folderMapping: null,
    workflowType: V2WorkflowType.INBOUND_REFERRAL_WF,
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateReceived }} Referral",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
  },
  [Classification.REFERRAL_AUTH]: {
    group: ConfigSubdomain.ADSS,
    classification: Classification.REFERRAL_AUTH,
    displayName: getClassificationDisplay(Classification.REFERRAL_AUTH, true),
    assignedTo: null,
    folder: null,
    folderMapping: null,
    workflowType: V2WorkflowType.FAX_WF,
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateReceived }} Prior Authorization",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
  },
  [Classification.OTHER]: {
    group: ConfigSubdomain.ADSS,
    classification: Classification.OTHER,
    displayName: getClassificationDisplay(Classification.OTHER, true),
    assignedTo: null,
    folder: null,
    folderMapping: null,
    workflowType: V2WorkflowType.FAX_WF,
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "Other",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
  },
};
